module.exports = __webpack_public_path__ + "static/media/finance.9cd31910.png";